import React from "react";
import * as Icons from "lucide-react";
import { programs, heroImages } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function Programs() {
  const { ref, inView } = useReveal();

  return (
    <section id="programs" className="relative py-24 bg-[#0d0d0f]">
      <div className="max-w-7xl mx-auto px-5">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""} flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6`}>
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-[2px] w-10 bg-gold" />
              <span className="section-label text-gold text-xs">Programs</span>
            </div>
            <h2 className="display-font uppercase text-white text-4xl sm:text-5xl lg:text-6xl max-w-2xl leading-[0.95]">
              Built for competition <span className="text-gold">& the next level.</span>
            </h2>
          </div>
          <p className="text-white/60 font-light max-w-sm">
            A competitive program built to push young adults toward college and the professional game.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {programs.map((p) => {
            const Icon = Icons[p.icon] || Icons.Circle;
            return (
              <div
                key={p.title}
                className="group relative rounded-lg overflow-hidden border border-white/10 bg-card p-7 hover:-translate-y-1 transition-all duration-300 hover:border-gold/50"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-md bg-gold/15 border border-gold/30 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-black transition-colors">
                    <Icon size={22} />
                  </div>
                  <span className="cond-font uppercase text-[11px] tracking-widest text-gold border border-gold/30 rounded-full px-3 py-1">
                    {p.tag}
                  </span>
                </div>
                <h3 className="cond-font uppercase tracking-wide text-xl text-white mt-6">{p.title}</h3>
                <p className="text-white/60 font-light mt-2 leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>

        {/* Feature banner */}
        <div className="relative mt-14 grid lg:grid-cols-2 rounded-xl overflow-hidden border border-white/10">
          <div className="relative min-h-[280px]">
            <img src={heroImages.youth} alt="youth training" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0d0d0f] lg:to-card" />
          </div>
          <div className="bg-card p-10 lg:p-12 flex flex-col justify-center">
            <span className="section-label text-gold text-xs">Player Pathway</span>
            <h3 className="display-font uppercase text-white text-3xl sm:text-4xl mt-4 leading-tight">
              From our squad to <span className="text-gold">college & pro.</span>
            </h3>
            <p className="mt-4 text-white/65 font-light">
              Every session is built around a professional standard of preparation, real match
              intensity and the exposure young adults need to reach the next level.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
